module.exports = __webpack_public_path__ + "img/main_culture1.6be46a66.png";